<template>
    <v-card style="display: inline-block; vertical-align: top"
            class="mr-4 mb-2"
            width="260px"
            color="#EAEAEA">
        <v-card-text class="pa-2">
            <h3>
                {{ sampleSet.name }}
            </h3>
            <perfect-scrollbar class="scroll-height"
                               :options="{ suppressScrollX: true }">
                <draggable class="sample-set-group"
                           :value="sampleSetTests"
                           group="sampleSet"
                           :disabled="!canEdit('SampleSetTests')"
                           @change="onCardChanged($event, sampleSet.id)">
                    <div v-for="(sampleSetTest, index) in sampleSetTests" :key="index">
                        <sampleSet-test :sampleSetTest="sampleSetTest" v-on="$listeners" />
                    </div>
                </draggable>
            </perfect-scrollbar>
        </v-card-text>
        <v-card-actions class="justify-center">
            <v-btn v-if="canEdit('SampleSetTests')" color="tertiary" dark @click="$emit('add', sampleSet.id)">Add SampleSet Test</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import Vue from "vue";
    import draggable from "vuedraggable";
    import PerfectScrollbar from "vue2-perfect-scrollbar";
    import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

    Vue.use(PerfectScrollbar);

    export default {
        components: {
            draggable,
            sampleSetTest: () => import("./SampleSetTest"),
        },
        props: {
            sampleSet: {
                type: Object,
                default: null,
            },
            sampleSetTests: {
                type: Array,
                default: () => [],
            },
            filter: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                isAdding: false,
            };
        },

        methods: {
            onCardChanged(value, sampleSetId) {
                if (!this.isEmpty(value.moved)) {
                    this.move(value.moved.element, sampleSetId);
                    return;
                }
                if (!this.isEmpty(value.added)) {
                    this.move(value.added.element, sampleSetId);
                }
            },

            async move(sampleSetTest, sampleSetId) {
                this.$emit("move", { sampleSetTest, sampleSetId });
            },
        },
    };
</script>

<style scoped>
    .scroll-height {
        height: 60vh;
    }

    .sample-set-group {
        min-height: 100%;
    }
</style>
